import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';
import { getCustomerPortalApiGroups } from 'utils/architecture/apiEndpoints';
import { CustomerPortalFlowDiagram } from 'components/architecture/CustomerPortalDiagram';

/**
 * Customer Portal APIs Page
 * Lists all customer portal API groups with links to endpoint pages
 */
const CustomerPortalAPIs = () => {
  const apiGroups = getCustomerPortalApiGroups();

  const sections = [
    {
      id: 'overview',
      title: 'Customer Portal APIs',
      content: [
        '<p>The Customer Portal APIs provide authenticated access to platform operations. All APIs require JWT authentication and are scoped to your tenant.</p>',
        '<ul>',
        '<li><strong>Base URL</strong>: <code>/api/customer_portal</code></li>',
        '<li><strong>Authentication</strong>: JWT token from Entra External ID</li>',
        '<li><strong>Rate Limiting</strong>: Applied per tenant and user</li>',
        '</ul>',
        <CustomerPortalFlowDiagram key="flow-diagram" />
      ]
    },
    {
      id: 'api-groups',
      title: 'API Groups',
      content: [
        '<p>The Customer Portal APIs are organized into the following groups:</p>',
        '<ul>',
        ...apiGroups.map(group => 
          `<li><a href="/architecture/processes/customer-portal/${group.id}"><strong>${group.name}</strong></a> - ${group.description}</li>`
        ),
        '</ul>',
        '<p>Click on any group above to view its endpoints and detailed documentation.</p>'
      ]
    },
    {
      id: 'navigation',
      title: 'Navigate to Endpoints',
      content: [
        '<p>Click on any endpoint above to view detailed documentation including:</p>',
        '<ul>',
        '<li>Technical description</li>',
        '<li>Request/response formats</li>',
        '<li>Authentication requirements</li>',
        '<li>Error handling</li>',
        '<li>Links to interactive API documentation</li>',
        '</ul>'
      ]
    }
  ];

  return (
    <ArchitectureLayout
      title="Customer Portal APIs"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default CustomerPortalAPIs;

